// removed by extract-text-webpack-plugin
module.exports = {"Langswitch":"_3FKARIp0LVYakbGAlkxyYK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSwitch/styles.css
// module id = 738
// module chunks = 0